import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderRecipesAndLinkedCustomerRecipesInput } from './GetOrderRecipesAndLinkedCustomerRecipesInput';
import { GetOrderRecipesAndLinkedCustomerRecipesOutput } from './GetOrderRecipesAndLinkedCustomerRecipesOutput';

export class GetOrderRecipesAndLinkedCustomerRecipesService extends HttpServiceBase {

  handle = (input?: GetOrderRecipesAndLinkedCustomerRecipesInput): Promise<Result<GetOrderRecipesAndLinkedCustomerRecipesOutput> | null> => {
    const promise = this.http.get<Result<GetOrderRecipesAndLinkedCustomerRecipesOutput>>(
      `${this.baseUrlSislogApi}/v2/order/${input?.orderId}/recipes-and-linked-customer-recipes`);
    return promise;
  }
}